// extracted by mini-css-extract-plugin
export var bodyRow = "_g4-d";
export var cardColumns = "_g4-e";
export var ellipsesOverflow = "_g4-2";
export var flatBottomCorners = "_g4-3";
export var flatTopCorners = "_g4-4";
export var headerActionsDropdown = "_g4-f";
export var headerBottomRow = "_g4-c";
export var headerTopRow = "_g4-b";
export var orderDetailsWrapper = "_g4-0";
export var orderInfoContainer = "_g4-1";
export var productDetails = "_g4-9";
export var productImage = "_g4-5";
export var responsiveTable = "_g4-8";
export var shipmentContainer = "_g4-a";
export var tableBottomLeft = "_g4-6";
export var tableBottomRight = "_g4-7";